/*
 * Module for the Participant Association Edit view
*/
rs.module("participant/account/associations/edit",

    ["controls/components/event-banner"],

    function (eventBanner) {

        //
        // Initialize
        //
        function initialize(jsSelectors) {

            // clear informational messages as the user switches tabs
            $.js(jsSelectors.tabs).find("[data-js=_tab]").click(function () {
                eventBanner.removeInformationalMessages();
            });
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);